import script from "./TalentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TalentCard.vue?vue&type=script&setup=true&lang=js"

import "./TalentCard.vue?vue&type=style&index=0&id=c26679da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c26679da"]])

export default __exports__